import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/keypad.vue
var o = {
	name: "DtIconKeypad",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--keypad"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Keypad",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M2.25 3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM5 3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm2.75 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm-5.5 2.75a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm2.75 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm2.75 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM2.25 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM5 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm2.75 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=keypad.js.map